import {
  HorizontalBorderOffsets,
  VerticalBorderOffsets
} from 'utils/open-floor-plan-walls';

export type OpenFloorPlanWallAppearance = {
  overlay: boolean;
  hasSectionColor: boolean;
  sectionColorBg?: string;
  conditioned: boolean;
  enlarged: boolean;
};

export function getOpenFloorPlanWallFillClass(
  appearance: OpenFloorPlanWallAppearance
): string {
  if (appearance.overlay) {
    return 'bg-gray-100';
  }
  if (appearance.hasSectionColor) {
    return '';
  }
  return appearance.conditioned ? 'bg-white' : 'bg-gray-200';
}

export function getOpenFloorPlanWallFillStyle(
  appearance: OpenFloorPlanWallAppearance
): { backgroundColor: string } | undefined {
  if (
    appearance.overlay ||
    !appearance.hasSectionColor ||
    !appearance.sectionColorBg
  ) {
    return undefined;
  }
  return { backgroundColor: appearance.sectionColorBg };
}

export function getTopWallPositionClass(enlarged: boolean): string {
  return enlarged ? '-top-2 h-4' : '-top-1 h-2';
}

export function getBottomWallPositionClass(enlarged: boolean): string {
  return enlarged ? '-bottom-2 h-4' : '-bottom-1 h-2';
}

export function getLeftWallPositionClass(enlarged: boolean): string {
  return enlarged ? '-left-2 w-4' : '-left-1 w-2';
}

export function getRightWallPositionClass(enlarged: boolean): string {
  return enlarged ? '-right-2 w-4' : '-right-1 w-2';
}

export function getCornerPatchPositionClass(
  corner: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right',
  enlarged: boolean
): string {
  if (enlarged) {
    if (corner === 'top-left') return '-left-2 -top-2 h-4 w-4';
    if (corner === 'top-right') return '-right-2 -top-2 h-4 w-4';
    if (corner === 'bottom-left') return '-bottom-2 -left-2 h-4 w-4';
    return '-bottom-2 -right-2 h-4 w-4';
  }
  if (corner === 'top-left') return '-left-1 -top-1 h-2 w-2';
  if (corner === 'top-right') return '-right-1 -top-1 h-2 w-2';
  if (corner === 'bottom-left') return '-bottom-1 -left-1 h-2 w-2';
  return '-bottom-1 -right-1 h-2 w-2';
}

export function wallTouchesStart(
  offsets: HorizontalBorderOffsets | VerticalBorderOffsets,
  startKey: 'left' | 'top'
): boolean {
  return offsets[startKey] <= 0;
}

export function wallTouchesEnd(
  offsets: HorizontalBorderOffsets | VerticalBorderOffsets,
  endKey: 'right' | 'bottom'
): boolean {
  return offsets[endKey] <= 0;
}

export function getHorizontalWallStyle(
  offsets: HorizontalBorderOffsets,
  appearance: OpenFloorPlanWallAppearance
): HorizontalBorderOffsets & { backgroundColor?: string } {
  return {
    ...offsets,
    ...getOpenFloorPlanWallFillStyle(appearance)
  };
}

export function getVerticalWallStyle(
  offsets: VerticalBorderOffsets,
  appearance: OpenFloorPlanWallAppearance
): VerticalBorderOffsets & { backgroundColor?: string } {
  return {
    ...offsets,
    ...getOpenFloorPlanWallFillStyle(appearance)
  };
}
